<template>
  <div class="invoice_container" :style="`min-height:${mh}px`">
    <Modal  :mask-closable="false" v-model="modal31" title="完全获得或生产">
      <p slot="header" style="color:#333; font-size:16px">
       
        <span>完全获得或生产</span>
     </p>
      <div
        v-for="(item, index) in ftaData0"
        :key="`page-${index}`"
        v-if="modal31index == index"
      >
        <div style="margin-bottom: 20px; font-size:16px; font-weight:bold;">
          请确认是否满足( <span style="color:red">{{ item.fta }}</span
          >)完全获得或生产规则
        </div>
        <p
          style="margin-bottom: 10px;white-space: pre-wrap;font-size: 15px;"
          v-html="item.content"
        ></p>

        <Button 
          type="primary"
          style="margin-right: 5px;font-size: 16px"
          @click="modal31index = index - 1"
          :disabled="modal31index == 0"
          >上一页</Button
        >
        <RadioGroup v-model="ftaData0[index].satisfyFlag" style="font-size: 16px;">
          <Radio :label="1"><span style="font-size:15px">满足</span></Radio>
          <Radio :label="0"><span style="font-size:15px">不满足</span></Radio>
        </RadioGroup>
   
        <Button style="font-size: 16px;"
          type="primary"
          @click="modal31index = index + 1"
          :disabled="modal31index == ftaData0.length - 1"
          >下一页</Button
        >
      </div>
      <div slot="footer">
        <span style="float: left;font-size:16px">当前第{{modal31index + 1}}页,共{{ ftaData0.length  }} 页</span>
        <Button type="primary" size="large"  style="font-size: 16px"  :disabled="modal31index != ftaData0.length - 1"  @click="modal3ok">确定</Button>
        <Button type="ghost" size="large" style="font-size: 16px" @click="modal31 = false">取消</Button>
      </div>
   
    </Modal>
    <Modal  :mask-closable="false" v-model="modal1" title="">
      <p slot="header" style="color:#333; font-size:16px">
       
        <span>新增预判定产品</span>
     </p>
      <div style="padding:20px 100px">
        <Button
          type="primary"
          class="searchprimary"
          @click="
            modal1 = false;
            modal2 = true;
            ftaData = [];
          "
          style="width:100%;font-size:16px"
          >完全获得或生产</Button
        >
        <Button type="primary"   class="searchprimary" @click="go" style="width:100%;margin-top:20px;font-size:16px"
          >非完全获得或生产</Button
        >
      </div>

      <div slot="footer"></div>
    </Modal>
    <Modal  :mask-closable="false" v-model="modal2" title="完全获得或生产-新增产品">
      <p slot="header" style="color:#333; font-size:16px">
       
        <span>完全获得或生产-新增产品</span>
     </p>
      <Form ref="formInline" inline :label-width="160">
        <Row>
          <Col span="24" class="reditem">
            <Form-item  label="商品编码(HS编码)" style="width:100%">
              <Product
                class="pr"
                ref="pr"
                currentState="rate"
                styleName="n"
              
              ></Product>
            </Form-item>
          </Col>

          <Col span="24" class="reditem">
            <Form-item
              prop="yuanchanguo"
              label="产品来源地"
              style="width:100%"
            >
              <Export
                class="ex"
                ref="ex"
                :width="'200%'"
                currentState="rate"
                styleName="n"
              
              ></Export> </Form-item
          ></Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button size="default" type="ghost" @click="modal2 = false" style="font-size: 16px;"
          >取消</Button
        >
        <Button size="default" type="primary" @click="getAdditional0" style="font-size: 16px;"
          >提交判定</Button
        >
      </div>
    </Modal>
    <Modal  :mask-closable="false"
     
    v-model="modal3"
    title="微小加工和处理"
  >
  <p slot="header" style="color:#333; font-size:16px">
       
    <span>微小加工和处理</span>
 </p>
     <div
      v-for="(item, index) in ftaData"
      :key="`page-${index}`"
      v-if="modal3index == index"
    >
      <div style="margin-bottom: 20px; font-size:16px; font-weight:bold;">
        请确认商品加工过程是否超出(<span style="color:red">{{ item.fta }}</span>)微小加工和处理
      </div>
      <p
        style="margin-bottom: 10px;font-size: 15px;
white-space: pre-wrap;"
        v-html="item.content"
      ></p>

      <Button
        type="primary"
        style="margin-right: 5px;font-size: 15px"
        @click="modal3index = index - 1"
        :disabled="modal3index == 0"
        >上一页</Button
      >
    
       <RadioGroup v-model="ftaData[index].satisfyFlag">
        <Poptip style="font-size: 15px"
         v-model="visible"
          confirm
          title="请确认，生产该商品仅使用了列表中所列的加工方式"
          @on-cancel="ftaData[index].satisfyFlag = 0"
        >
          <Radio :label="1"> <span  @click="visible=true" style="display:inline-block;width:50px;text-align:left;font-size: 15px"> 不超出</span></Radio>
        </Poptip>

        <Radio :label="0"><span @click="visible=false" style="display:inline-block;width:50px;text-align:left;font-size: 15px"> 超出</span></Radio>
      </RadioGroup>
     
      <Button   style="font-size: 16px"
        type="primary"
        @click="modal3index = index + 1"
        :disabled="modal3index == ftaData.length - 1"
        >下一页</Button
      >
     
    </div>
    <div slot="footer">
      <span  style="float: left;font-size:15px">当前第{{modal3index + 1}}页,共{{ ftaData.length  }} 页</span>
      <Button type="primary" size="large"   style="font-size:15px"  :disabled="modal3index != ftaData.length - 1"  @click="submitJudgment(1)">确定</Button>
      <Button type="ghost" size="large"  style="font-size:15px" @click="modal3 = false">取消</Button>
    </div>

  </Modal>
  <Modal v-model="modal" @on-ok="modal = false" @on-cancel="modal = false">
    <p>请确认，生产该商品仅使用了列表中所列的加工方式</p>
  </Modal>
  <Modal
    v-model="modal4"
    title="加工工序/化学反应"
  >
  <p slot="header" style="color:#333; font-size:16px">
       
    <span>加工工序/化学反应</span>
 </p>
    <div
      v-for="(item, index) in processData"
      :key="`page-${index}`"
      v-if="modal4index == index"
    >
      <div style="margin-bottom: 20px; font-size:16px; font-weight:bold;">
        {{ item.ftaName }}
      </div>
      <p
        style="margin-bottom: 10px;white-space: pre-wrap;font-size: 15px;"
        v-html="item.show"
      ></p>

      <Button
        type="primary"
        style="margin-right: 5px; font-size: 15px"
        @click="modal4index = index - 1"
        :disabled="modal4index == 0"
        >上一页</Button
      >
 
      <RadioGroup v-model="processData[index].satisfyFlag"    style="font-size: 15px">
        <Radio :label="1">满足</Radio>
        <Radio :label="0">不满足</Radio>
      </RadioGroup>

      <Button
        type="primary"
        @click="modal4index = index + 1"
        :disabled="modal4index == processData.length - 1"
        >下一页</Button
      >
    </div>
    <div slot="footer">
      <span  style="float: left;font-size:15px">当前第{{modal4index + 1}}页,共{{ processData.length  }} 页</span>
      <Button type="primary" size="large" style="font-size: 15px"   :disabled="modal4index != processData.length - 1"  @click="submitJudgment(2)">确定</Button>
      <Button type="ghost" size="large" style="font-size: 15px" @click="modal4 = false;buttonconfirm1 == true">取消</Button>
     
    </div>
  </Modal>

    <div class="query_box boxshadow1">
      <div class="query_conf">
        <div class="slogo-title">原产地历史判定查询</div>
        <div class="query_conf_items">
          <div class="query_conf_title">国别查询</div>
          <div class="query_conf_wrap">
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">原产国/地区</div>
                <div class="value">
                  <Exportnew
                  v-model="conf.exporter"
              
                  :width="'200%'"
                  styleName="n"
                ></Exportnew>
                
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">进口国/地区</div>
                <div class="value">
                  <Exportnew
                  v-model="conf.importer"
              
                  :width="'200%'"
                  styleName="n"
                ></Exportnew>
              
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="query_conf_items">
          <div class="query_conf_title keys">关键字查询</div>
          <div class="query_conf_wrap">
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">商品名称</div>
                <div class="value">
                  <Input
                    v-model.trim="conf.name"
                    placeholder="输入商品名称"
                  ></Input>
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">发票号</div>
                <div class="value">
                  <Input
                    v-model.trim="conf.invoice"
                    placeholder="输入发票号"
                  ></Input>
                </div>
              </div>
            </div>
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">成品料号</div>
                <div class="value">
                  <Input
                    v-model.trim="conf.pn"
                    placeholder="输入成品料号"
                  ></Input>
                </div>
              </div>
            </div>
          
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title">成品商品编码</div>
                <div class="value">
                  <Input
                    v-model.trim="conf.code"
                    placeholder="输入成品商品编码"
                  ></Input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="query_conf_items">
          <div class="query_conf_title keys">高级查询</div>
          <div class="query_conf_wrap">
            <div class="query_conf_item">
              <div class="query_conf_item_wrap">
                <div class="title pro2">有效状态</div>
                <div class="value">
                  <Select clearable v-model="conf.loseStatus">
                    <Option value="0">失效</Option>
                    <Option value="1">有效</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="query_conf_item" >
              <div class="query_conf_item_wrap">
                <div class="title">判定日期</div>
                <div class="value">
                  <DatePicker
                    class="dateselect"
                    v-model.trim="dateRange"
                    type="daterange"
                    placement="bottom-start"
                    split-panels
                    clearable
                    :editable="false"
                    placeholder="请选择日期"
                    @on-change="dateSearch"
                    style="width:100%;"
                  ></DatePicker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" actions">
          <Button style="width: 170px;"
            type="ghost"
            class="add"
            shape="circle"
            icon="search"
            @click.prevent="searchHandle"
            ><span>搜索</span></Button
          >
          <Button
          style="width: 170px;background-color: #8ac3fa;border-color: #8ac3fa;"
          type="ghost"
          class="upload"
          shape="circle"
          icon="refresh"
            @click.prevent="resetHandle"
            :disabled="searching"
            ><span>{{ $t("btn.reset") }}</span></Button
          >
        </div>
      </div>
    </div>

    <div class="opr_acitons boxshadow1">
      <div class="actions">
        <Button style="width: 170px;"
          type="ghost"
          shape="circle"
          class="add"
          icon="ios-search"
          @click.prevent="addProduct"
          >新增商品预判定</Button
        >
 

      <a v-if="url == 'rcep.otechsolution.com'"
      href="
      https://otech-rcep.oss-cn-hangzhou.aliyuncs.com/%E5%8E%9F%E4%BA%A7%E5%9C%B0%E5%88%A4%E5%AE%9A%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
      target="_blank"
      class="dw_tpl"
    >
      <Button type="ghost" shape="circle"   class="edit" style="margin-left:0;margin-left:20px"
      icon="ios-download-outline

      " 
        >
        模板下载</Button
      >
    </a>
    <a v-else
    href="
    https://otech-rcep-test.oss-cn-hangzhou.aliyuncs.com/%E5%8E%9F%E4%BA%A7%E5%9C%B0%E5%88%A4%E5%AE%9A%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
    target="_blank"
    class="dw_tpl"
  >
    <Button type="ghost" shape="circle"   class="edit" style="margin-left:0;margin-left:20px"
    icon="ios-download-outline

    " 
      >
      模板下载</Button
    >
  </a>

        <Button
          type="ghost"
          shape="circle"
          class="upload"
          :loading="uploading"
          icon="ios-search"
          @click.prevent="importFile"
        >
      
          <span v-if="!uploading">批量导入</span>
          <span v-else>导入中<span style="display: none"> 100%</span></span>
        </Button>
   

        <!-- <Button 
        type="ghost"
        style="margin-right:20px"
        shape="circle"
        class="add ownbtn"
        @click.prevent="submitJudgment(0,'yuanchanguo')"
      >
        <Icon type="ios-paperplane" style="margin-right: 5px;"></Icon
        >原产国判定</Button> -->


        <input
          type="file"
          ref="fileInput"
          @change="fileChange($event)"
          class="upload-input"
        />
        <Button
          type="ghost"
          shape="circle"
          class="del"
          icon="ios-search"
          @click.prevent="batchDel"
          >删除</Button
        >
       
        <!-- <a
        href="https://otech-rcep.oss-cn-hangzhou.aliyuncs.com/%E5%8E%9F%E4%BA%A7%E5%9C%B0%E5%88%A4%E5%AE%9A/%E5%8D%95%E4%B8%80%E7%AA%97%E5%8F%A3%E5%8E%9F%E4%BA%A7%E5%9C%B0%E8%AF%81%E8%B4%A7%E7%89%A9%E6%95%B0%E6%8D%AE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%EF%BC%882007%E7%89%88%EF%BC%89.xlsx"
        target="_blank"
        class="dw_tpl"
      >
        <Button type="ghost" shape="circle"   class="edit" style="margin-left:0;"
        icon="ios-download-outline
  
        " 
          >
          导出</Button
        >
      </a> -->
      <!-- <Poptip confirm title="你确定要执行失效操作吗?" @on-ok="loseStatus">
        <Button type="ghost" shape="circle"   class="del"
        icon="ios-search"
          ><Icon type="trash-a" style="margin-right: 5px;"></Icon>失效</Button
        >
      </Poptip> -->

    

        <Loader
          :loadType="1"
          v-show="isShowModalLoader"
          class="black"
          style="top:-20px;"
        ></Loader>
      </div>
    </div>

    <div class="query_result boxshadow1">
      <div class="content">
        <div class="table-containter">
          <div class="table-wrap">
            <Table
              :columns="query.columns"
              :data="query.list"
              :loading="loaderQuery"
              no-data-text="暂无记录"
              @on-selection-change="selectionChange"
            ></Table>
          </div>
          <div class="border-wrap"></div>
        </div>
        <Page
          :total="query.total"
          :page-size="pageSize"
          :current="currentPage"
          size="small"
          @on-change="getQueryList"
        
        ></Page>
      </div>
    </div>
    <DoingModal :isShow="isShowDoingModal" :index="doingStep"></DoingModal>
    <Statement></Statement>
  </div>
</template>
<script>
import minxins from "@/components/common/minxins";
import { createNamespacedHelpers } from "vuex";
import Loader from "@/components/layout/Loader";
import DoingModal from "./doingModal";
import Product from "@/components/common/Product2";
import Export from "@/components/common/Export2";
import Exportnew from "@/components/common/Export3";
import Statement from "@/components/layout/statement";
const {
  mapState: mapDataState,
  mapGetters: mapDataGetters
} = createNamespacedHelpers("data");

export default {
  name: "InvoiceList",
  components: { Loader, DoingModal, Statement, Export, Product, DoingModal,Exportnew },
  props: ["mh"],
  mixins: [minxins],
  data() {
    return {
      url:'',
      pandingtype:'',
      visible:false,
      ftaData: [],
      cloasemodal3: false,
   
      modal:false,
      processData: [],
      isShowDoingModal: false,
      doingStep: 0,
      modal3index: 0,
      modal31index: 0,
      modal4index: 0,

      doingStep: 0,
      doingTimer: null,
      uploading: false,
      searching: false,
      dateRange: "",
      modeldata: "",
      conf: {
        importer: null,
        exporter: null,
        invoice: null,
        pn: null,
        name: null,
        code: null,
        key: null,
        status: null,
        startTime: null,
        endTime: null
      },
      ftaData0:[],
      submitNew: false,
      modal1: false,
      modal2: false,
      pageSize: 10,
      currentPage: 1,
      totalPage: 1,
      loaderQuery: false,
      isShowModalLoader: false,
      selectedID: [],
      modal3: false,
      modal31: false,
      buttonconfirm1: false,
      modal4: false,
      query: {
        total: 0,
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
            fixed: 'left'
          },
         

          // {title: '公司代码', key: 'companyCode', align: 'center', width: 100, className: 'tb_company'},

       
          {
            title: '状态',
            key: 'status',
            align: 'center',
            minWidth: 120,
            fixed: 'left',
            render: (h, params) => {
              return h('span', {
                style: { color: {'_0': '#fb8181', '_-1': '#fb8181', '_1': '#666', '_2': '#20ea20', '_10': '#999'}['_'+parseInt(params.row.status)] }
              }, this.$options.filters.getCooStatus(params.row.status))
            }
          },
          {
            title: '操作',
            key: 'action',
            minWidth: 220,
            fixed: 'left',
            render: (h, params) => {
              return h('div', {
                class: 'opr'
              }, [
                params.row.status != 10? h('div', {
                  style: {color: '#bd8af1', display: 'inline-block', marginRight: '8px'},
                  class: 'line2',
                  on: {
                    click: event => {

                      this.selectedID = [params.row.id]
                      event.stopPropagation()
                      event.preventDefault()
                      this.editProduct();
                    }
                  }
                 
              
                }, '编辑') : '',
                params.row.status !== 1 && params.row.determinationId ? h('div', {
                  style: {color: '#ffa797', display: 'inline-block', marginRight: '8px'},
                  class: 'line2',
                  on: {
                    click: event => {

                      let whollyObtained = params.row.whollyObtained
                              ? params.row.whollyObtained
                              : 0
                      let href = this.$router.resolve({
                          path: "/rules/decide/vote/result/" + params.row.determinationId + "/" + whollyObtained,
                          query: { type: whollyObtained }
                      })
                
                      window.open(href.href, '_blank')



  


                      
                    }
                  }
                }, '查看') : '',
                params.row.status != 10? h('a', {
                  style: {color: '#8ac3f8'},
                  class: 'line2',
                  on: {
                    click: event => {

                      event.stopPropagation()
                      event.preventDefault()
                      this.selectedID = [params.row.id]
                    
                      this.submitJudgment(0,'tijiaopanding')
                    }
                  }
                }, '预判定') : '',
                params.row.status == 2 && params.row.determinationId? h('a', {
                  style: {color: '#8c79f1', display: 'inline-block', marginLeft: '8px'},
                  class: 'line2',
                  on: {
                    click: event => {
                      event.stopPropagation()
                      event.preventDefault()
                      this.cooArchive(params.row.id)
                    }
                  }
                }, '归档') : ''
              ])
            }
          },
    
         
          {title: '起运地', key: 'exporter', minWidth: 150, align: 'center'},
          {title: '目的地', key: 'importer', minWidth: 150, align: 'center'},
          {
            title: '发票号',
            key: 'invoiceCode',
            align: 'center',
            minWidth: 150,
            ellipsis: true,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.invoiceCode}
              }, params.row.invoiceCode)
            }
          },
          {
            title: '成品料号',
            key: 'goodsPN',
            align: 'center',
            ellipsis: true,
            minWidth: 150,
            render: (h, params) => {
              return h('router-link', {
                style: {color: '#0774b5', textDecoration: 'underline'},
                attrs: {title: params.row.goodsPN},
                props: {
                  to: {name: 'InvoiceMaterialShow', params: {id: params.row.id}}
                }
              }, params.row.goodsPN)
            }
          },
          {
            title: '成品名称',
            key: 'goodsName',
            align: 'center',
            ellipsis: true,
            minWidth: 150,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.goodsName}
              }, params.row.goodsName)
            }
          },
          {
            title: '成品商品编码',
            key: 'goodsCode',
            align: 'center',
            ellipsis: true,
            minWidth: 150,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.goodsCode}
              }, params.row.goodsCode)
            }
          },
          {
            title: '成品单价',
            key: 'goodsPrice',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              if(!params.row.unit || !params.row.goodsPrice){
                return h('span', '-')

              }
              let unit = '-'
              if(params.row.unit){
                unit = params.row.unit
              }
              return h('span', (this.$options.filters.amountThousands(params.row.goodsPrice || 0) || '-') + unit)
            }
          },
          // {
          //   title: '成品数量',
          //   key: 'goodsCount',
          //   align: 'center',
          //   render: (h, params) => {
          //     return h('span', params.row.goodsCount || '-')
          //   }
          // },
          {
            title: '成品重量',
            key: 'goodsWeight',
            minWidth: 150,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.goodsWeight || '-')
            }
          },
          // {title: '单位', key: 'unit', align: 'center', width: 80},
          // {
          //   title: '包含进口成份',
          //   key: 'imported',
          //   align: 'center',
          //   minWidth: 100,
          //   render: (h, params) => {
          //     return h('span', params.row.imported == 'Y'? '是' : '否')
          //   }
          // },
          // {
          //   title: '具有加工工序',
          //   key: 'specialCraft',
          //   align: 'center',
          //   minWidth: 100,
          //   render: (h, params) => {
          //     return h('span', params.row.specialCraft == 'Y'? '是' : '否')
          //   }
          // },
          {
            title: '备注',
            key: 'goodsDescription',
            align: 'center',
            ellipsis: true,
            minWidth: 150,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.goodsDescription}
              }, params.row.goodsDescription)
            }
          },
          {
            title: '时间',
            key: 'lastTime',
            align: 'center',
            minWidth: 250,
            render: (h, params) => {
              return h('span', params.row.lastTime)
            }
          }
        ],
        list: []
      }
    };
  },
  watch: {
   
    pandingtype(newVal, oldVal) {
      if (newVal) {
        this.ftaData = [];
        this.processData = [];
        
      }
    },
  },
  computed: {
    apiPrice() {
      if (this._.isEmpty(this.apiValue)) {
        return null;
      } else {
        return this.getApiValue();
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  created() {
    this.url = window.location.hostname;
    
    let _endTime = new Date();
    let _startTime = new Date(_endTime.getTime() - 3600 * 1000 * 24 * 30);
    this.conf.startTime = this.$options.filters.dataFormat(
      +_startTime,
      "dateTime.short5"
    );
    this.conf.endTime = this.$options.filters.dataFormat(
      +_endTime,
      "dateTime.short5"
    );
    this.dateRange = [_startTime, _endTime];
  },
  mounted() {
    this.$nextTick(() => {
      this.getQueryList();
    });
  },
  methods: {
    doradio(val) {

      if (val == 1) {
        this.modal = true;
      }
    },
    rowClassName(row, index) {
      if (row.whollyObtained == 1) {
        return "table-yuanchandi-row";
      } else return "";
    },

    closeDropdown(event, componentName) {
      this.setAutomatic(componentName, false);
    },
    loseStatus(event, componentName) {
      if (this.selectedID && this.selectedID.length > 0) {
        this.$api.coo.goods.loseStatus(
          { ids: this.selectedID },
          {
            success: response => {
              if (response.data.code === 200) {
                this.getQueryList(1);
              } else {
                this.$Message.warning({
                  content: this.$t("common.codeError"),

                  closable: true
                });
              }
            },
            error: errorMsg => {
              this.searching = false;

              this.$Message.error({
                content: this.$t("common.tryAgain"),

                closable: true
              });
              this.$Loading.error();
            }
          }
        );
      } else {
        this.$Message.warning({
          content: "请选择需要操作的项",
          duration: 1.5,
          closable: true
        });
      }
    },
    handleClick(event, componentName) {
      switch (componentName) {
        case "exporter":
          this.$refs.pr.closeDowndown(false);
          break;
        case "importer":
          this.$refs.ex.closeDowndown(false);
          this.$refs.pr.closeDowndown(false);
          break;
        case "product":
          this.$refs.ex.closeDowndown(false);

          break;
      }
    },
    gopage(determinationId, whollyObtained) {
      this.$router.push({
        path: "/rules/decide/vote/result/" + determinationId + "/" + whollyObtained,
        query: { type: whollyObtained }
      });
    },
    async submitJudgment(fromtanchuang,type) {
   
      if(type){
        this.pandingtype = type
      }
  
     
      
      if (this.selectedID && this.selectedID.length != 1) {
        this.$Message.error({
          content: "请选择一条数据进行操作",
          closable: true
        });
        return;
      } 
    

      for (let index = 0; index < this.query.list.length; index++) {
        if (this.query.list[index].id == this.selectedID[0]) {
          let row = this.query.list[index];
          if (row.whollyObtained == 1) {
            this.$api.coo.goods.getAdditional(
              { exporter: row.exporterId, importer: row.importerId, type: 1 },
              {
                success: response => {
                  if (response.data.code === 200) {
                    this.modal2 = false;

                    this.submitNew = true;
                    this.ftaData0 = response.data.data;
                    if (this.ftaData0.length > 0) {
                      this.modal31 = true;
                      this.modal31index = 0;
                    } else {
                      this.modal3ok();
                    }

                   
                  } else {
                    this.$Message.warning({
                      content: this.$t("common.codeError"),

                      closable: true
                    });
                  }
                  this.isShowModalLoader = false;
                  this.searching = false;
                  this.loaderQuery = false;
                },
                error: errorMsg => {
                  this.isShowModalLoader = false;
                  this.searching = false;
                  this.loaderQuery = false;
                  this.$Message.error({
                    content: this.$t("common.tryAgain"),

                    closable: true
                  });
                  this.$Loading.error();
                }
              }
            );
          } else {
            if(fromtanchuang==0){
              this.ftaData = []
              this.processData = []
              this.modal3index = 0
              this.modal4index = 0
              
              this.modal4 = false
         
              let _ftaData =  await this.$api.coo.goods.getAdditional2({
                  exporter: row.exporterId,
                  importer: row.importerId,
                  type: 2
                })

              let _processData = await this.$api.coo.goods.getProcessingProcedure( {hsCode:row.goodsCode,exporter:row.exporterId,importer:row.importerId})
         
              if (_ftaData.data.data.length > 0) {
                for (
                  let index = 0;
                  index < _ftaData.data.data.length;
                  index++
                ) {
                  _ftaData.data.data[index].satisfyFlag = 0;
                }
              }
              this.ftaData = _ftaData.data.data;
              this.processData = _processData.data.data;
              if(this.ftaData.length>0){
                this.modal3 = true
              }
              if(this.ftaData.length==0 && this.processData.length>0){
                this.modal4 = true
              }
              if(this.ftaData.length==0 && this.processData.length==0){
                
                if(this.pandingtype=='tijiaopanding'){
                  this.cooHandle2(row.id,row.whollyObtained);
                }
                if(this.pandingtype=='yuanchanguo'){
                  this.determinationCountryid(row.id,row.whollyObtained);
                }
              }
              

            }
            if(fromtanchuang==1 && this.processData.length>0){
         
              this.modal3 = false
              this.modal4 = true
              this.modal4index = 0
              return
            }
            if(fromtanchuang==1 && this.processData.length==0){
                if(this.pandingtype=='tijiaopanding'){
                  this.cooHandle2(row.id,row.whollyObtained);
                }
                if(this.pandingtype=='yuanchanguo'){
                  this.determinationCountryid(row.id,row.whollyObtained);
                }

            }
            if(fromtanchuang==2 ){
            
             
              let processDataflag = true;
              for (
                  let index = 0;
                  index < this.processData.length;
                  index++
                ) {
                  if (
                    !this.processData[index].satisfyFlag &&
                    this.processData[index].satisfyFlag != 0
                  ) {
                    processDataflag = false;
                  }
              }
              if (processDataflag == false) {
                
                this.$Message.error('加工工序有数据没有选择')
                return;
              }
              else{
                this.modal4 = false
                if(this.pandingtype=='tijiaopanding'){
                  this.cooHandle2(row.id,row.whollyObtained);
                }
                if(this.pandingtype=='yuanchanguo'){
                  this.determinationCountryid(row.id,row.whollyObtained);
                }

              }
              

              

            }
              
                
              

           
          }
        }
      }
    },
 
    modal3ok() {
      let exporter = this.$refs.ex.value.id;
      let goodsCode = this.$refs.pr.value.id;
      let flag = true;
      for (let index = 0; index < this.ftaData0.length; index++) {
        if (
          !this.ftaData0[index].satisfyFlag &&
          this.ftaData0[index].satisfyFlag != 0
        ) {
          flag = false;
        }
        if (!this.$refs.pr.value.id) {
          for (let index = 0; index < this.query.list.length; index++) {
            if (this.query.list[index].id == this.selectedID[0]) {
              let row = this.query.list[index];
              if (!this.$refs.pr.value.id) {
                this.ftaData0.goodsCode = row.goodsCode;
              }

              if (!this.$refs.ex.value.id) {
                exporter = row.exporterId;
              }
              if (!this.$refs.pr.value.id) {
                goodsCode = row.goodsCode;
              }
            } else {
              this.ftaData0.goodsCode = this.$refs.pr.value.id;
            }
          }
        }
      }
      if (!flag) {
        this.$Message.error({
          content: "请对每页数据进行完满足不满足选择再进行操作"
        });
        return;
      }
      if (this.submitNew) {
        this.$api.coo.goods.whollyObtained(
          {
            exporter: exporter,
            ftaData: this.ftaData0,
            goodsCode: goodsCode,
            importer: 27
          },

          {
            success: response => {
             
              if (response.data.code === 200) {
           
                this.gopage(
                  response.data.data.id,
                          1
                );
              } else {


                this.$Message.error({
                    content: response.data.message
                  });

              }
            },
            error: errorMsg => {
              this.isShowModalLoader = false;
              this.searching = false;
              this.loaderQuery = false;
              this.$Message.error({
                content: response.data.message,
                duration: 1.5,
                closable: true
              });
              this.$Loading.error();
            }
          }
        );
      } else {
        this.cooHandle2(id,1);
      }
    },
    cooHandle2(id,whollyObtained) {
      if (this.isShowDoingModal) return;
      this.$Loading.start();
      this.doingStep = 0;
      this.isShowDoingModal = true;
      this.doingTimer = setTimeout(() => {
        this.doingStep = 1;
        this.doingTimer = setTimeout(() => {
          this.doingStep = 2;
        }, this._.random(1000, 2000));
      }, this._.random(200, 800));

        this.$api.coo.determination.submit(
        this.selectedID[0],
        { ftaData: this.ftaData, processData: this.processData},
        {
          success: response => {
            this.setDoingState(() => {
              this.$Loading.finish();
              this.$Message.destroy();
              if (response.data.code === 200) {
                this.$Message.success({
                  content: "操作成功",
                  closable: true
                });
                this.gopage(
                  response.data.data.id,
                  whollyObtained
                );
              } else {
                this.$Message.warning({
                  content: "判定失败请稍后重试",
                  duration: 1.5,

                  onClose: () => {
                    this.$router.push({ name: "RulesDecide" });
                    this.isSaving = false;
                    this.isSaving2 = false;
                  }
                });
              }
            });
          },
          error: errorMsg => {
            this.setDoingState(() => {
              this.$Message.error({
                content: this.$t("common.tryAgain"),
                duration: 1.5,
                closable: true,
                onClose: () => {
                  this.$router.push({ name: "RulesDecide" });
                  this.isSaving = false;
                  this.isSaving2 = false;
                }
              });
              this.$Loading.error();
            });
          }
        }
      );
    },
    determinationCountryid(id,whollyObtained) {
      if (this.isShowDoingModal) return;
      this.$Loading.start();
      this.doingStep = 0;
      this.isShowDoingModal = true;
      this.doingTimer = setTimeout(() => {
        this.doingStep = 1;
        this.doingTimer = setTimeout(() => {
          this.doingStep = 2;
        }, this._.random(1000, 2000));
      }, this._.random(200, 800));

      let data = this.query.list.find((item)=>{ return  item.id==this.selectedID[0]})    





      this.$api.coo.determination.determinationCountry(
        this.selectedID[0],
     
        { ftaData: this.ftaData, processData: this.processData,
        
        
        
        },
        {
          success: response => {
            this.setDoingState(() => {
              this.$Loading.finish();
              this.$Message.destroy();
              if (response.data.code === 200) {
                this.$Message.success({
                  content: "操作成功",

                  closable: true
                });
                this.gopage(
                  response.data.data.id,
                  whollyObtained
                );
              } else {
                this.$Message.warning({
                  content: "判定失败请稍后重试",
                  duration: 1.5,

                  onClose: () => {
                    this.$router.push({ name: "RulesDecide" });
                    this.isSaving = false;
                    this.isSaving2 = false;
                  }
                });
              }
            });
          },
          error: errorMsg => {
            this.setDoingState(() => {
              this.$Message.error({
                content: this.$t("common.tryAgain"),
                duration: 1.5,
                closable: true,
                onClose: () => {
                  this.$router.push({ name: "RulesDecide" });
                  this.isSaving = false;
                  this.isSaving2 = false;
                }
              });
              this.$Loading.error();
            });
          }
        }
      );
    },
    cooHandle(id) {
      if (this.isShowDoingModal) return;
      this.GJFNotice(status => {
        if (status) {
          let jf = this.getApiValue()(6);
          if (jf && jf.integral && jf.integral > 0) {
            this.GConfirm(
              `本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`,
              status => {
                if (status) {
                  this.doCoo(id);
                }
              }
            );
          } else {
            this.doCoo(id);
          }
        } else {
          this.doCoo(id);
        }
      });
    },
    cooArchive(id) {
      this.$Modal.confirm({
        title: "归档",
        content: "归档后不可再次编辑和判定，是否确认归档？",
        onOk: () => {
          this.dooCooArchive(id);
        }
      });
    },
    dooCooArchive(id) {
      this.$Loading.start();
      this.$api.coo.determination.archive(id, {
        success: response => {
          this.$Loading.finish();
          this.$Message.destroy();
          if (response.data.code === 200) {
            let idx = this._.findIndex(this.query.list, o => o.id == id);
            if (idx != -1)
              this.$set(
                this.query.list,
                idx,
                this._.assign(this.query.list[idx], { status: 10 })
              );
            this.$Message.success({
              content: "归档成功",
              duration: 1.5,
              closable: true
            });
          } else {
            this.$Message.warning({
              content: "归档失败，请重试",
              duration: 1.5,
              closable: true
            });
          }
        },
        error: errorMsg => {
          this.$Message.error({
            content: this.$t("common.tryAgain"),
            duration: 1.5,
            closable: true
          });
          this.$Loading.error();
        }
      });
    },
    doCoo(id) {
      this.$Loading.start();
      this.doingStep = 0;
      this.isShowDoingModal = true;
      this.doingTimer = setTimeout(() => {
        this.doingStep = 1;
        this.doingTimer = setTimeout(() => {
          this.doingStep = 2;
        }, this._.random(1000, 2000));
      }, this._.random(200, 800));
      this.$api.coo.determination.submit(
        id,
        {},
        {
          success: response => {
            this.setDoingState(() => {
              this.$Loading.finish();
              this.$Message.destroy();
              if (response.data.code === 200) {
                setTimeout(() => {
                  this.$router.push({
                    name: "RulesDecideVoteResult",
                    params: { id: response.data.data.id }
                  });
                }, 2000);
              } else {
                this.$Message.warning({
                  content: this.$t("common.codeError"),
                  duration: 1.5,
                  closable: true
                });
              }
            });
          },
          error: errorMsg => {
            this.setDoingState(() => {
              this.$Message.error({
                content: this.$t("common.tryAgain"),
                duration: 1.5,
                closable: true
              });
              this.$Loading.error();
            });
          }
        }
      );
    },
    getQueryList(page = 1) {
      this.currentPage = page
   
      if (this.isShowModalLoader) return;
      this.$Loading.start();
      // this._h.scrollTop()
      this.isShowModalLoader = true;
      this.searching = true;
      this.loaderQuery = true;
  
      this.selectedID = [];
      this.$api.coo.goods.list(
        this._.assign({ page: page || 1, size: this.pageSize }, this.conf),
        {
          success: response => {
            this.$Loading.finish();
            if (response.data.code === 200) {
              response.data.data.result.map((item, index) => {
                if (item.loseStatus == 0) {
                  response.data.data.result[index]._disabled = true;
                } else {
                  response.data.data.result[index]._disabled = false;
                }
              });

              this.query.list = response.data.data.result || [];
              this.query.total = response.data.data.count || 0;
              this.totalPage = response.data.data.pageCount || 0;
            } else {
              this.$Message.warning({
                content: response.data.message,
                duration: 1.5,
                closable: true
              });
            }
            this.isShowModalLoader = false;
            this.searching = false;
            this.loaderQuery = false;
          },
          error: errorMsg => {
            this.isShowModalLoader = false;
            this.searching = false;
            this.loaderQuery = false;
            this.$Message.error({
              content: this.$t("common.tryAgain"),
              duration: 1.5,
              closable: true
            });
            this.$Loading.error();
          }
        }
      );
    },
    dateSearch(dateArr, dateType) {
      if (!this._.isEmpty(dateArr) && dateType === "date") {
        this.conf.startTime = dateArr[0];
        this.conf.endTime = dateArr[1];
      } else {
        this.conf.startTime = null;
        this.conf.endTime = null;
        this.dateRange = "";
      }
    },
    importFile() {
      if (!this.uploading) {
        this.$refs.fileInput.click();
      }
    },
    fileChange(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;
      this.uploadFiles(files);
    },
    uploadFiles(files) {
      if (!files || files.length === 0) return;
      let isRefused = false;
      this._.each(files, file => {
        if (file.size > 100 * 1024 * 1024) {
          this.$Message.error({
            content: "上传文件过大，请上传不超过100M的文件",
            duration: 1.5,
            closable: true
          });
          isRefused = true;
          return false;
        }
        let suffix = this._h.getSuffix(file.name);
        if (this._.indexOf([".xls", ".xlsx"], suffix) === -1) {
          this.$Message.error({
            content: "上传文件类型错误，请上传Excel文件",
            duration: 1.5,
            closable: true
          });
          isRefused = true;
          return false;
        }
      });
      if (isRefused) {
        this.$refs.fileInput.value = null;
        return;
      }
      if (!this.uploading) {
        this.$Loading.start();
        this.uploading = true;
        let formData = new FormData();
        formData.append("file", files[0]);
        this.$api.upload("ruling/goods/import", formData, {
          success: response => {
            if (response.data.code === 200) {
              this.$Message.success({ content: "上传成功", duration: 1.5 });
              this.getQueryList(1);
              this.$Loading.finish();
              this.uploading = false;
              this.$refs.fileInput.value = null;
            } else {
              this.$Loading.error();
              if (
                this._.indexOf([203001, 203002, 203003], response.data.code) !==
                -1
              ) {
                this.$Message.error({
                  content: response.data.message,
                  duration: 2,
                  closable: true
                });
              } else {
                this.$Message.error({
                  content: response.data.message || "文件解析失败，请重试",
                  duration: 2,
                  closable: true
                });
              }
              this.uploading = false;
              this.$refs.fileInput.value = null;
            }
          },
          error: errorMsg => {
            this.$Loading.error();
            this.$Message.error({
              content: errorMsg || "文件上传失败，请重试",
              duration: 2,
              closable: true
            });
            this.uploading = false;
            this.$refs.fileInput.value = null;
          }
        });
      }
    },
    selectionChange(selection) {
      if (selection) {
        this.selectedID = this._.map(selection, item => item.id);
      }
    },
    searchHandle() {
      this.getQueryList(1);
    },
    resetHandle() {
      this.conf = {
        invoice: null,
        exporter: null,
        importer: null,
        pn: null,
        name: null,
        code: null,
        key: null,
        startTime: null,
        endTime: null,
        status: null
      };
      this.dateRange = "";
    },
    getAdditional0() {

      this.modal2 = true;
      if (!this.$refs.ex.value.id) {
        this.$Message.error({
          content: "请先选择来源地"
        });

        return;
      }
      if (!this.$refs.pr.text ) {
        this.$Message.error({
          content: "请先选择商品编码"
        });

        return;
      }

      if (this.$refs.pr.text.length<6 ) {
        this.$Message.error({
          content: "商品编码不能小于6位"
        });

        return;
      }
      this.ftaData0 = [];
      this.$api.coo.goods.getAdditional(
        { exporter: this.$refs.ex.value.id, importer: 27, type: 1 },
        {
          success: response => {
            if (response.data.code === 200) {
              this.modal2 = false;

              this.ftaData0 = response.data.data;
              if (this.ftaData0.length > 0) {
                this.modal31 = true;
                this.modal31index = 0;
              } else {
                this.modal3ok();
              }
            } else {
              this.$Message.warning({
                content: this.$t("common.codeError"),
                duration: 1.5,
                closable: true
              });
            }
            this.isShowModalLoader = false;
            this.searching = false;
            this.loaderQuery = false;
          },
          error: errorMsg => {
            this.isShowModalLoader = false;
            this.searching = false;
            this.loaderQuery = false;
            this.$Message.error({
              content: this.$t("common.tryAgain"),
              duration: 1.5,
              closable: true
            });
            this.$Loading.error();
          }
        }
      );
    },
    getAdditional() {
      this.this.ftaData = [];
      this.$api.coo.goods.getAdditional(
        { exporter: this.$refs.ex.value.id, importer: 27, type: 1 },
        {
          success: response => {
            if (response.data.code === 200) {
              this.modal2 = false;
              this.modal3 = true;
              this.modal3index = 0;


            let _ftaData= response.data.data
              if (_ftaData.length > 0) {
                    for (
                      let index = 0;
                      index < _ftaData.length;
                      index++
                    ) {
                      _ftaData[index].satisfyFlag = 0;
                    }
                  }
              
              this.ftaData = _ftaData;

            } else {
              this.$Message.warning({
                content: this.$t("common.codeError"),
                duration: 1.5,
                closable: true
              });
            }
            this.isShowModalLoader = false;
            this.searching = false;
            this.loaderQuery = false;
          },
          error: errorMsg => {
            this.isShowModalLoader = false;
            this.searching = false;
            this.loaderQuery = false;
            this.$Message.error({
              content: this.$t("common.tryAgain"),
              duration: 1.5,
              closable: true
            });
            this.$Loading.error();
          }
        }
      );
    },
    go() {
      this.$router.push({ path: "/rules/decide/add" });
    },
    addProduct() {
      this.submitNew = true;
      this.modal1 = true;
      this.$refs.pr.setDefaultValue({ id: "", text: "" });
      this.$refs.ex.setDefaultValue({ id: "", text: "" });
      // this.$router.push({ name: "InvoiceMaterialAdd" });
    },
    editProduct() {
      if (this.selectedID && this.selectedID.length != 1) {
        this.$Message.warning({
          content: "请选择一条需要编辑的项",

          closable: true
        });
      } else {
        for (let index = 0; index < this.query.list.length; index++) {
          if (this.query.list[index].id == this.selectedID[0]) {
            let row = this.query.list[index];
            if (row.whollyObtained == 1) {
              this.modal2 = true;

              this.$refs.ex && this.$refs.ex.resetContent(false);

              this.$refs.pr && this.$refs.pr.resetContent(false);
           
              this.$refs.ex.setDefaultValue({ id: row.exporterId, text: row.exporter });
              this.$refs.pr.setDefaultValue({ id: row.goodsCode, text: row.goodsCode });
         
              this.submitNew = true;
            }
            if (row.whollyObtained == 0 || !row.whollyObtained) {



            
                      let href = this.$router.resolve({
                path: "/rules/decide/edit/" + this.selectedID[0]
              })
                
                      window.open(href.href, '_blank')






              // this.$router.push({
              //   path: "/rules/decide/edit/" + this.selectedID[0]
              // });
            }
          }
        }
      }

      // if (row.status != 10) {
      //
      // }
    },
    onCopy() {
      if (this.selectedID && this.selectedID.length == 1) {
        // let selectedData = this._.find(this.query.list, o => o.id == this.selectedID[0])
        // if (!this._.isEmpty(selectedData)) {
        //   this.$router.push({name: 'InvoiceMaterialAdd', query: { d: JSON.stringify(selectedData) }})
        // }
        this.$router.push({
          name: "InvoiceMaterialAdd",
          query: { d: this.selectedID[0] }
        });
      } else {
        this.$Message.warning({
          content: "请选择需要复制的项",
          duration: 1.5,
          closable: true
        });
      }
    },
    batchDel() {
      if (this.selectedID && this.selectedID.length > 0) {
        this.$api.coo.goods.batchDel(this.selectedID, {
          success: response => {
            this.isShowModalLoader = false;
            if (response.data.code === 200) {
              this.$Loading.finish();
              this.getQueryList(1);
              this.selectedID = [];
            } else {
              this.$Loading.error();
              this.$Message.warning({
                content: this.$t("common.codeError"),
                duration: 1.5,
                closable: true
              });
            }
          },
          error: errorMsg => {
            this.$Loading.error();
            this.$Message.error({
              content: "删除失败，请重试",
              duration: 1.5,
              closable: true
            });
            this.isShowModalLoader = false;
          }
        });
      } else {
        this.$Message.warning({
          content: "请选择需要删除的项",
          duration: 1.5,
          closable: true
        });
      }
    },
    setDoingState(callback) {
      if (this.doingTimer !== null) {
        clearTimeout(this.doingTimer);
        if (this.doingStep === 0) {
          this.doingStep = 1;
          setTimeout(() => {
            this.doingStep = 2;
            setTimeout(() => {
              this.doingStep = 3;
              setTimeout(() => {
                this.isShowDoingModal = false;
                callback && callback();
              }, 800);
            }, this._.random(1000, 1500));
          }, this._.random(200, 800));
        } else if (this.doingStep === 1) {
          this.doingStep = 2;
          setTimeout(() => {
            this.doingStep = 3;
            setTimeout(() => {
              this.isShowDoingModal = false;
              callback && callback();
            }, 800);
          }, this._.random(1000, 2500));
        } else if (this.doingStep === 2) {
          this.doingStep = 3;
          setTimeout(() => {
            this.isShowDoingModal = false;
            callback && callback();
          }, 800);
        }
      }
    },
    ...mapDataGetters(["getApiValue"])
  }
};
</script>
<style scoped>
  .invoice_container{
    background-color: #fff;
    padding: 5px 0 0;
  }
  .query_box{
    margin-bottom: 30px;
  }
  .query_result{
    padding: 6px 18px 24px;
  }
  .query_conf{
    font-size: 16px;
    padding: 18px 18px 22px;
  }
  .slogo-title{
    color: #333;
    font-weight: bold;
    font-size: 16px;
    padding: 0 18px 10px 0;
  }
  .query_conf_title{
    color: #999;
    font-size: 16px;
    margin-bottom: 6px;
    padding-left: 16px;
    background: url("~@/assets/images/home/rate2.png") no-repeat 0 center transparent;
    background-size: 11px;
  }
  .query_conf_title.keys{
    background: url("~@/assets/images/home/pro2.png") no-repeat 0 5px transparent;
    background-size: 11px;
  }
  .query_conf_wrap{
    margin-left: -10px;
    margin-right: -10px;
    display: flex;
    flex-wrap: wrap;
  }
  .query_conf_item{
    width: 20%;
  }
  .query_conf_item_wrap{
    margin: 0 10px 16px;
  }
  .query_conf_item_wrap .title{
    font-size: 16px;
    margin-bottom: 2px;
    /* padding-left: 16px;
    background: url("~@/assets/images/home/rate2.png") no-repeat 0 center transparent;
    background-size: 11px; */
  }
  .query_conf_item_wrap .title.pro2{
    /* background: url("~@/assets/images/home/pro2.png") no-repeat 0 5px transparent;
    background-size: 11px; */
  }
 
  .query_conf_item_wrap >>> .ivu-input,
  .query_conf_item_wrap >>> .ivu-select-selection{
    border-color: #b1b1b1;
    border-radius: 2px;
    font-size: 16px;
  }
  .query_conf_item_wrap >>> .ivu-select-selected-value{
    font-size: 16px !important;
  }
  .query_conf_item_wrap >>> .ivu-select-placeholder{
    font-size: 16px !important;
  }
  .query_conf_item_wrap >>> .ivu-select-item{
    font-size: 16px !important;
  }
  .btns_wrap{
    height: 32px;
    margin-top: 10px;
  }
  .query_conf >>> .ivu-row{
    margin-bottom: 20px;
  }
  .query_conf >>> .ivu-row .ivu-col{
    display: flex;
    align-items: center;
  }
  .query_conf >>> .ivu-row .ivu-col .title{
    white-space: nowrap;
  }
  .query_conf >>> .ivu-row .ivu-col .ivu-input{
    border-color: #DBDBDB;
    border-radius: 2px;
  }
  .query_conf >>> .ivu-row .ivu-col .ivu-input:focus{
    border-color: #57a3f3;
  }
  >>> .ivu-btn-primary {
    color: #fff;
    background-color: #8892f3;
    border-color: #8892f3;
  }
  .btn{
    max-width: 180px;
    width: 18.4%;
    border: 1px solid #8892f3;
    border-radius: 3px;
    height: 32px;
    /*line-height: 32px;*/
    float: left;
    /*font-size: 12px;*/
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    letter-spacing: 2px;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.search{
    background-color: #8892f3;
    color: #fff;
  }
  .btn.edit{
    background-color: #8892f3;
    color: #fff;
  }
  .searchprimary{
    background-color: #8892f3;
    color: #fff;
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
  .btn.reset{
    background-color: #fff;
    color: #8892f3;
    margin-left: 20px;
  }
  .btn.reset[disabled]{
    color: #bbbec4;
    /*background-color: #f7f7f7;*/
    border-color: #dddee1;
    cursor: default;
  }
  .opr_acitons{
    padding: 16px 18px;
    margin-bottom: 30px;
  }
  .actions{
    position: relative;
  }
  .actions .add{
    border: 1px solid #bc8cf0;
    background-color: #bc8cf0;
    color: #fff;
  }
  .actions .edit{
    background-color: #8892f3;
    color: #fff;
    margin-left: 20px;
  }
  .upload-input{
    display: none;
  }
  .actions >>> .ivu-btn{
    border-radius: 2px;
  
    font-size: 16px;
  }
 
  .actions >>> .ivu-btn .ivu-icon-ios-search{
    background: url("~@/assets/images/home/add.png") 0 center no-repeat transparent;
    background-size: 16px;
    width: 16px;
    height: 16px;
    position: relative;
    top: 2px;
  }
  .actions >>> .upload.ivu-btn .ivu-icon-ios-search{
    background-image: url("~@/assets/images/home/import.png");
  }
  .actions >>> .del.ivu-btn .ivu-icon-ios-search{
    background-image: url("~@/assets/images/home/del.png");
  }
  .actions >>> .ivu-btn>.ivu-icon+span, .ivu-btn>span+.ivu-icon{
    margin-left: 2px;
  }
  .actions >>> .ivu-btn .ivu-icon-ios-search:before{
    content: "";
  }
  .actions >>> .ivu-btn .ivu-icon-ios-edit:before{
    content: "\f2bf"
  }
  .actions .upload{
    border: 1px solid #ffa799;
    background-color: #ffa799;
    color: #fff;
    margin: 0 20px;
  }
  .actions .del{
    border: 1px solid #8ac3fa;
    background-color: #8ac3fa;
    color: #fff;
    margin-right:20px;
  }
  .actions .copy{
    border-color: #0774b5;
    color: #0774b5;
  }
  .actions .copy[disabled]{
    color: #ccc;
    border-color: #ccc;
  }
  .actions .copy >>> .ivu-icon{
    font-size: 20px;
    position: relative;
    top: 2px;
  }
  .actions .right_action{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
  .actions .right_action .cert_btn{
    color: #1F8AFD;
    background: url("~@/assets/images/coo/icon_zhengshuguanli.png") 0 center no-repeat transparent;
    background-size: 13px auto;
    padding-left: 16px;
  }
  .actions .right_action .dw_tpl{
    display: inline-block;
    margin-left: 10px;
    font-size: 16px;
    /* color: #0774b5; */
  }
  >>>.ivu-btn-primary.disabled, .ivu-btn-primary.disabled.active, .ivu-btn-primary.disabled:active, .ivu-btn-primary.disabled:focus, 
  .ivu-btn-primary.disabled:hover, .ivu-btn-primary[disabled], .ivu-btn-primary[disabled].active, .ivu-btn-primary[disabled]:active, 
  .ivu-btn-primary[disabled]:focus, .ivu-btn-primary[disabled]:hover, fieldset[disabled] .ivu-btn-primary, fieldset[disabled] 
  .ivu-btn-primary.active, fieldset[disabled] .ivu-btn-primary:active, fieldset[disabled] .ivu-btn-primary:focus, fieldset[disabled] .ivu-btn-primary:hover{
    color: #bbbec4;
    background-color: #f7f7f7;
    border-color: #dddee1;
  }
  .actions .right_action .dw_tpl:hover{
    text-decoration: underline;
  }
  .content{
    margin-top: 20px;
    position: relative;
  }
  .table-containter{
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 3px;
  }
  /* .table-containter .border-wrap{
    border: 1px solid #eaf7ff;
    position: absolute;
    top: 0;
    bottom: 9px;
    left: 0;
    width: 100%;
    z-index: 2;
  } */
.table-wrap{
  width: 100%;
  border: 1px solid #eaf7ff;
  /* overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 3px; */
}
/* .table-containter::-webkit-scrollbar-track-piece {
  background: transparent;
}
.table-containter::-webkit-scrollbar {
  height: 6px;
}
.table-containter::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
} */
.table-wrap >>> .ivu-table-wrapper{
  /* width: 2300px; */
}
.table-wrap >>> .opr{
  white-space: nowrap;
}
.table-wrap >>> .ivu-table-body tr:nth-child(even) td{
  background-color: #eaf7ff;
}
.table-wrap >>> .ivu-table:before, .table-wrap >>> .ivu-table:after{
  background-color: #eaf7ff;
}

  .content >>> .ivu-table-wrapper{
    border: 0 none;
    /* box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50); */
  }
  .content >>> .ivu-table{
    color: #686765;
  }
  .content >>> .ivu-table th{
    background-color: #eaf7ff;
    font-size: 16px;
    font-weight: bold;
    border-color: #eaf7ff;
    white-space: nowrap;
  }
  .content >>> .ivu-table th span{
    white-space: nowrap;
  }
  .content >>> .ivu-table td{
    font-size: 16px;
    /* border-color: #eaf7ff; */
    border-width: 0;
  }
  .content >>> .ivu-table .ivu-checkbox-wrapper{
    margin-right: 0;
  }
  .content >>> .ivu-table .tb_select .ivu-table-cell{
    padding-right: 0;
  }
  .content >>> .ivu-table .tb_company .ivu-table-cell{
    padding-left: 0;
  }
  .content >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .ivu-page{
    margin-top: 20px;
    margin-bottom: 16px;
    text-align: right;
  }
  .ivu-page >>> a{
    font-size: 16px;
  }
  .ivu-page >>> a:hover{
    color: #0774b5;
  }
  .ivu-page >>> .ivu-page-prev a, .ivu-page >>> .ivu-page-next a{
    font-size: 22px;
  }
  .ivu-page >>> .ivu-page-item{
    margin: 0 5px;
  }
  .reditem >>> .ivu-form-item-label:before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 16px !important;
    color: #ed3f14;
  }
  .reditem >>> .ivu-form-item-label{
  
    font-size: 16px !important;
    
  }
  .ivu-page >>> .ivu-page-item-active{
    background-color: #0774b5;
    border-color: #0774b5;
  }
</style>




// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/InvoiceList.vue